import { render, staticRenderFns } from "./artikelbilder.vue?vue&type=template&id=6433284a"
import script from "./artikelbilder.vue?vue&type=script&lang=js"
export * from "./artikelbilder.vue?vue&type=script&lang=js"
import style0 from "./artikelbilder.vue?vue&type=style&index=0&id=6433284a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./artikelbilder.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports